export default "__VITE_ASSET__4d590266__"